export default __webpack_public_path__ + "static/media/0_lower_left.d33c7bee.svg";